import React, {Component} from 'react';
import {OptionalBrowserRouter} from '../../helpers/routerCompat';
import PopupBase from './PopupBase';
import LoginLink from './LoginLink';

export default class LoginPopup extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.close = this.close.bind(this);
  }

  close(e) {
    e.preventDefault();
    this.ref.current.close();
  }

  render() {
    return (
      <PopupBase
        ref={this.ref}
        titleHtml={<i className="icon-b icon-b-address-card" />}
        title="Please login or create account"
        className="login-required-popup"
        onEscape={() => false}
        closeButton
      >
        <OptionalBrowserRouter>
          <div>
            <p>
              You’re just a few steps away from accessing our industry-leading property research
              tool.
            </p>
            <div className="buttons">
              <LoginLink className="btn" />
              <LoginLink urlType="register" className="btn-grey" text="Create account" />
            </div>
          </div>
        </OptionalBrowserRouter>
      </PopupBase>
    );
  }
}
